import { render } from "./upload-photo-cod-reconcile.vue?vue&type=template&id=2a656e32&scoped=true&ts=true"
import script from "./upload-photo-cod-reconcile.vue?vue&type=script&lang=ts"
export * from "./upload-photo-cod-reconcile.vue?vue&type=script&lang=ts"

import "./upload-photo-cod-reconcile.vue?vue&type=style&index=0&id=2a656e32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a656e32"]])

export default __exports__